import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectTopModal, cancelTopModal } from "../../features/modal/modalSlice";
import { ZeusAlertModal, ZeusActionModal, ZeusLoader } from "zeus-front-design-system";
import * as styles from "./AppModals.module.scss";
import { selectGlobalLoading } from "../../features/ui/uiSlice";
import { resolveConfirm } from "../../services/confirmServices";

// Si tienes slices específicos que también marcan busy, puedes sumarlos aquí
// import { selectEmergency, selectIsAnyDeleting } from "../features/emergency/emergencySlice";

const AppModals: React.FC = () => {
  const dispatch = useAppDispatch();
  const modal = useAppSelector(selectTopModal);
  const isGlobalBusy = useAppSelector(selectGlobalLoading);

  // Combina con otros flags si quieres
  // const { loading } = useAppSelector(selectEmergency);
  // const isAnyDeleting = useAppSelector(selectIsAnyDeleting);
  // const isBusy = isGlobalBusy || loading || isAnyDeleting;

  const isBusy = isGlobalBusy;

  if (!modal && !isBusy) return null;

  if (isBusy) {
    return (
      <div className={styles.backgroundModal}>
        <ZeusLoader />
      </div>
    );
  }

  if (modal?.type === "CONFIRM_GENERIC") {
    return (
      <div className={styles.backgroundModal}>
        <ZeusActionModal
          title={modal.title}
          alertTitle=""
          subtitle={modal.subtitle ?? ""}
          type="info"
          onAccept={() => resolveConfirm(modal.id, true)}
          onClose={() => resolveConfirm(modal.id, false)}
          acceptBtnTxt={modal.confirmText ?? "Aceptar"}
          cancelBtnTxt={modal.cancelText ?? "Cancelar"}
        />
      </div>
    );
  }

  return (
    <div className={styles.backgroundModal}>
      <ZeusAlertModal
        title={modal!.title}
        subtitle={modal!.subtitle ?? ""}
        type={
          modal!.type === "ALERT_SUCCESS"
            ? "success"
            : modal!.type === "ALERT_INFO"
              ? "info"
              : "error"
        }
        confirmationButton={{
          text: "Aceptar",
          onClick: () => dispatch(cancelTopModal()),
        }}
      />
    </div>
  );
};

export default AppModals;
